import {t} from "@lingui/core/macro";
import * as React from "react";

import PageRoot from "#app-shell-package/page-root.tsx";

import AboutHeader from "./about-header.tsx";
import AboutNav from "./about-nav.tsx";
import {withStrings} from "./locales/contribute-credits-page/load-strings.tsx";
import VolunteerCredits from "./volunteer-credits.tsx";

type Props = Record<any, any>;

/**
 * Render the /contribute/credits page on corporate donation matching.
 */
export default withStrings(
    (props: Props): React.ReactElement => (
        <PageRoot settings={{title: t`Our Contributors`}}>
            <div className="about-page">
                <AboutHeader pageheadline={t`Our Contributors`} />
                <AboutNav />
                <VolunteerCredits />
            </div>
        </PageRoot>
    ),
);
